// Contents
import React, { useEffect, useState, useMemo } from 'react';
import PageHero from "../pageHero/PageHero_Projects.jsx";
import ProjectList from "../pages/projects/ProjectList.jsx";
import { supabase } from '../../utils/supabase.js';

export default function Projects({ navigate, lang }) {
    const [projectRows, setProjectRows] = useState(null);
    const [translationRows, setTranslationRows] = useState(null);
    const [uiRows, setUiRows] = useState(null);

    useEffect(() => {
        Promise.all([
            supabase.from('projects').select('id, slug, info, image_list, image_swiper, swiper_show, agency, date, url, position, outils, images').order('position'),
            supabase.from('projects_translations').select('project_id, lang, title, content, agency'),
            supabase.from('projects_ui').select('key, fr, en'),
        ]).then(([projRes, transRes, uiRes]) => {
            if (projRes.data) setProjectRows(projRes.data);
            if (transRes.data) setTranslationRows(transRes.data);
            if (uiRes.data) setUiRows(uiRes.data);
        });
    }, []);

    const uiMap = useMemo(() => {
        if (!uiRows) return null;
        const map = {};
        uiRows.forEach(r => { map[r.key] = { fr: r.fr, en: r.en }; });
        return map;
    }, [uiRows]);

    const allProjects = useMemo(() => {
        if (!projectRows || !translationRows) return null;
        return projectRows.map(p => {
            const trans = translationRows.find(t => t.project_id === p.id && t.lang === lang);
            return {
                ...p,
                imageList: p.image_list,
                imageSwiper: p.image_swiper,
                swiperShow: p.swiper_show,
                title: trans?.title ?? '',
                content: trans?.content ?? '',
                agency: trans?.agency ?? p.agency,
            };
        });
    }, [projectRows, translationRows, lang]);

    return (<>
        <PageHero navigate={navigate} lang={lang} />
        <ProjectList navigate={navigate} lang={lang} data={allProjects} uiMap={uiMap} />
    </>);
}